<template>
  <div class="modal" :class="{ 'd-block': showModal }" id="productModal" tabindex="-1" role="dialog"
       aria-labelledby="productModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" style="maxWidth: 900px;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="productModalLabel">
            Просмотр товаров в продаже</h5>
          <b-button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
          </b-button>
        </div>
        <div class="modal-body">
          <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
            <div v-if="this.orderDataIsLoading">
              <CircleProgress/>
            </div>
          </transition>

          <table class="products-preview">
            <thead>
            <tr>
              <th>Продукт</th>
              <th>Количество</th>
              <th>Скидка</th>
              <th>Цена</th>
              <th>Цена со скидкой</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in clientProducts.orderItems" :key="index">
              <td>{{getProductNameById(item.productId) }}</td>
              <td>{{item.quantity }}</td>
              <td>{{item.discount }}%</td>
              <td>{{getPriceWithoutDiscount(item.productId, item.quantity,)}} BYN</td>
              <td>{{getTotalPrice(item.productId, item.quantity, item.discount)}} BYN</td>
            </tr>
            </tbody>
          </table>
          <div style="margin-top: 16px;">ИТОГО: {{
              getTotalFinalPrice()
            }}
            BYN
          </div>
          <div style="margin-top: 8px;">С УЧЕТОМ СКИДКИ: {{ getTotalFinalDiscountPrice() }}
            BYN
          </div>
          <div style="color: #008a00;" class="sub-total" v-if="clientProducts.oplacheno != null && clientProducts.oplacheno != 0">ОПЛАЧЕНО: {{
              clientProducts.oplacheno.toFixed(2)
            }}
            BYN
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CircleProgress from "../CircleProgress.vue";
import velocity from "velocity-animate";
import axios from "@/axios";

export default {
  name: "ProductsInSale",
  components: {
    CircleProgress
  },
  data() {
    return {
      products: [],
      formErrors: {
        name: false,
        equipmentCost: false,
        rentCost: false,
        qty: false
      },
    };
  },
  computed: {
    showModal:{
      get() {
        return this.$store.state.productsInSales;
      },
    },
    orderDataIsLoading: {
      get() {
        return this.$store.state.orderViewProductsIsLoading;
      },
    },
    clientProducts: {
      get() {
        return this.$store.state.orderProductsView;
      },
    }
  },
  methods: {
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      velocity(el, {opacity: 1}, {duration: 500, complete: done});
    },
    leave(el, done) {
      velocity(el, {opacity: 0}, {duration: 500, complete: done});
    },
    fetchProducts() {
      let url = '/api/product';
      axios.get(url).then(response => {
        this.products = response.data;
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
      });
    },
    getOrderTotalPrice() {
      console.log("ORDERS IN MODAL: ", this.clientProducts)
      let totalPrice = 0;
      for (let i = 0; i < this.clientProducts.length; i++) {
        totalPrice += Number(this.getTotalPrice(this.clientProducts[i].productId, this.clientProducts[i].quantity, this.clientProducts[i].discount));
      }
      return totalPrice.toFixed(2);
    },
    getProductNameById(id) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id == id) {
          return this.products[i].name;
        }
      }
      return 'Продукт не найден';
    },
    getTotalPrice(id, count, discount) {
      const price = this.getProductPriceById(id);
      let totalPrice = count * price;
      if (discount !== 0) {
        totalPrice = totalPrice * (1 - discount / 100);
      }
      totalPrice = totalPrice.toFixed(2);
      return totalPrice;

    },
    getPriceWithoutDiscount(id, count) {
      const price = this.getProductPriceById(id);
      let totalPrice = count * price;
      totalPrice = totalPrice.toFixed(2);
      return totalPrice;
    },
    getOrderTotalPriceWithoutDiscount() {
      let totalPrice = 0;
      for (let i = 0; i < this.clientProducts.length; i++) {
        totalPrice += Number(this.getPriceWithoutDiscount(this.clientProducts[i].productId, this.clientProducts[i].quantity));
      }
      return totalPrice.toFixed(2);
    },
    getProductPriceById(id) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id == id) {
          return this.products[i].equipmentCost;
        }
      }
      return 0;
    },
    setShowModal(active) {
      this.$store.commit('updateProductsInSale', active);
    },
    setIsLoading(active) {
      this.$store.commit('updateOrderViewDataIsLoading', active);
    },
    clearViewData(){
      this.$store.commit('updateOrderViewProducts', []);
    },
    closeModal() {
      this.setShowModal(false);
      this.clearViewData();
    },
    getTotalFinalPrice()  {
      let total = this.clientProducts.paymentAmount;
      total = total.toFixed(2);
      return total;
    },
    getTotalFinalDiscountPrice()  {
      let total = this.clientProducts.endPrice;
      total = total.toFixed(2);
      return total;
    },
  },
  mounted() {
    this.setIsLoading(true);
    this.fetchProducts();
    this.setIsLoading(false);
  }
}


</script>

<style scoped>


.products-preview {
  margin-top: 16px;
  width: 100%;
}

td, th {
  width: auto;
  font-size: 0.8rem;
}

.sub-total {
  margin-top: 8px;
  font-size: 0.8rem;
  font-weight: 600;
}

</style>